"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m17.93 16 1.63-1.63c-2.77-3.02-2.77-7.56 0-10.74L17.93 2c-3.9 3.89-3.91 9.95 0 14m4.99-5.05c-.84-1.18-.84-2.71 0-3.89l-1.68-1.69c-2.02 2.02-2.02 5.07 0 7.27zM9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m6.39 2.56C13.71 14.7 11.53 14 9 14s-4.71.7-6.39 1.56C1.61 16.07 1 17.1 1 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66"
}), 'Transcribe');